

// @vendor
const Cookies = require('js-cookie');


const hasLocalStorage = (function() {
    try {
        localStorage.setItem('foo', 'bar');
        localStorage.removeItem('foo');
        return true;
    } catch (e) {
        return false;
    }
}());

const hasSessionStorage = (function() {
    try {
        sessionStorage.setItem('foo', 'bar');
        sessionStorage.removeItem('foo');
        return true;
    } catch (e) {
        return false;
    }
}());

const cookiesMethods =  {
    set: function(key, value, attributes = {}, isContactCenter, isLocal, tokenCredential, cookiesDomain){
        value = JSON.stringify(value);
        if (!isLocal) {
            attributes.domain = cookiesDomain;
            attributes.secure = true;
        }
        // This is here to avoid changes in all places where token credential is obtained from cookies
        if (isContactCenter && key === tokenCredential && hasLocalStorage) {
            localStorage.setItem(key, value);
        } else {
            Cookies.set(key, value, attributes);
        }
    },
    get: function(key, isContactCenter, tokenCredential) {
        let value;
        // This is here to avoid changes in all places where token credential is obtained from cookies
        if (isContactCenter && key === tokenCredential && hasLocalStorage) {
            value = localStorage.getItem(key);
        } else {
            value = Cookies.get(key);
        }
        try {
            return JSON.parse(value);
        } catch (err) {
            return value;
        }
    },
    remove: function(key, attributes, isContactCenter, tokenCredential) {
        // This is here to avoid changes in all places where token credential is obtained from cookies
        if (isContactCenter && key === tokenCredential && hasLocalStorage) {
            localStorage.removeItem(key);
        } else {
            Cookies.remove(key, attributes);
        }
    }
}

const localStorageMethods = {
    set: function(key, value, isContactCenter, isLocal, tokenCredential, cookiesDomain){
        value = JSON.stringify(value);
        if (hasLocalStorage) {
            localStorage.setItem(key, value);
        } else {
            cookiesMethods.set(key, value, null, isContactCenter, isLocal, tokenCredential, cookiesDomain);
        }
    },
    get: function(key, isContactCenter, tokenCredential) {
        if (hasLocalStorage) {
            const value = localStorage.getItem(key);
            try {
                return JSON.parse(value);
            } catch (err) {
                return value;
            }
        } else {
            return cookiesMethods.get(key, isContactCenter, tokenCredential);
        }
    },
    remove: function(key, isContactCenter, tokenCredential) {
        if (hasLocalStorage) {
            localStorage.removeItem(key);
        } else {
            cookiesMethods.remove(key, null, isContactCenter, tokenCredential);
        }
    }
}

const sessionStorageMethods = {
    set: function(key, value, isContactCenter, isLocal, tokenCredential, cookiesDomain){
        value = JSON.stringify(value);
        if (hasSessionStorage) {
            sessionStorage.setItem(key, value);
        } else {
            cookiesMethods.set(key, value, null, isContactCenter, isLocal, tokenCredential, cookiesDomain);
        }
    },
    get: function(key, isContactCenter, tokenCredential) {
        if (hasSessionStorage) {
            const value = sessionStorage.getItem(key);
            try {
                return JSON.parse(value);
            } catch (err) {
                return value;
            }
        } else {
            return cookiesMethods.get(key, isContactCenter, tokenCredential);
        }
    },
    remove: function(key, isContactCenter, tokenCredential) {
        if (hasSessionStorage) {
            sessionStorage.removeItem(key);
        } else {
            cookiesMethods.remove(key, null, isContactCenter, tokenCredential);
        }
    }
}

module.exports = {
    cookies: cookiesMethods,
    localStorage: localStorageMethods,
    sessionStorage: sessionStorageMethods,
    hasLocalStorage
};
